/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_ShowInputs */

const cs_builder_preview_show = /** @type {(inputs: Builder_Preview_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit náhled`)
};

const en_builder_preview_show = /** @type {(inputs: Builder_Preview_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show preview`)
};

/**
* | output |
* | --- |
* | "Show preview" |
*
* @param {Builder_Preview_ShowInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_show = /** @type {((inputs?: Builder_Preview_ShowInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_ShowInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_show(inputs)
	return cs_builder_preview_show(inputs)
});